import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface IGuide
{
    title: string,
    description: string,
    item: {
        description: string,
        image: string
    }[]
}

@Component({
    selector: 'app-guide',
    templateUrl: './guide.component.html',
    styleUrls: [ './guide.component.scss' ]
})
export class GuideComponent
{
    @Input('guide-export') guide: IGuide;
    @Output() onClose: EventEmitter<any> = new EventEmitter();
    public guideExport;
    public guideItems: {
        current: number, maxSlide: number, description: string, elementSlide:
        {
            description: string,
            image: string, active: boolean
        }[]
    };

    ngOnInit()
    {
        this.guideExport = this.guide;

        this.guideItems = {
            current: 0,
            description: '',
            maxSlide: this.guideExport.item.length,
            elementSlide: [],
        }

        for (let item of this.guideExport.item)
        {
            this.guideItems.elementSlide.push({
                active: false,
                description: item.description,
                image: item.image
            })
        }

        this.guideItems.elementSlide[ this.guideItems.current ].active = true;
        this.guideItems.description = this.guideItems.elementSlide[ this.guideItems.current ].description;
    }

    public onBack()
    {
        console.log('onBack');
        this.onClose.emit();
    }

    public onRight()
    {
        this.guideItems.elementSlide[ this.guideItems.current ].active = false;

        if (this.guideItems.current + 1 < this.guideItems.maxSlide)
        {
            this.guideItems.current += 1
        }

        this.guideItems.elementSlide[ this.guideItems.current ].active = true;
        this.guideItems.description = this.guideItems.elementSlide[ this.guideItems.current ].description;
    }

    public onLeft()
    {
        this.guideItems.elementSlide[ this.guideItems.current ].active = false;

        if (this.guideItems.current - 1 >= 0)
        {
            this.guideItems.current -= 1
        }

        this.guideItems.elementSlide[ this.guideItems.current ].active = true;
        this.guideItems.description = this.guideItems.elementSlide[ this.guideItems.current ].description;
    }
}
